import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentService, isExpirationAlert, ScreenService} from '@app/core';
import {Document} from '@app/shared';
import {GlobalValuesService} from '../../../core/services/global-values.service';
import {combineLatest, take} from 'rxjs';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {DocDrawerComponent} from '../doc-drawer/doc-drawer.component';

@Component({
  selector: 'app-doc-badget-status',
  standalone: false,

  templateUrl: './doc-badget-status.component.html',
  styleUrl: './doc-badget-status.component.less'
})
export class DocBadgetStatusComponent {

  @Input() document!: Document;
  @Input() showName?: boolean = false;
  @Input() ignoreExpiration?: boolean = false;
  @Output() deleteEvent = new EventEmitter<void>();
  docDrawer: any;
  protected readonly isExpirationAlert = isExpirationAlert;

  constructor(
    private gs: GlobalValuesService,
    private screenService: ScreenService,
    private drawerService: NzDrawerService,
    private documentService: DocumentService,
  ) {
  }

  getDocumentTypeName(documentTypeId: number): string | undefined {
    return (this.gs.documentTypes$?.value || []).find(dt => dt.id === documentTypeId)?.name;
  }

  shouldShowExpirationAlert(): any {
    if (this.ignoreExpiration) {
      return false;
    }
    return this.isExpirationAlert(this.document.expirationDate);
  }

  getButtonClasses(): string {
    if (this.ignoreExpiration) {
      return 'normal';
    }
    
    const expirationData = this.isExpirationAlert(this.document.expirationDate);
    if (expirationData && expirationData.alertState) {
      return expirationData.alertState === 'nearExp' 
        ? 'st-badget expiration-badget' 
        : 'st-badget expired-badget';
    }
    return 'normal';
  }

  getIconName(): string {
    if (this.ignoreExpiration) {
      return 'description';
    }
    
    const expirationData = this.isExpirationAlert(this.document.expirationDate);
    return expirationData?.alertState ? 'quick_reference' : 'description';
  }


  getTooltipText(): string {
    if (this.ignoreExpiration) {
      return '';
    }
    
    const expirationData = this.isExpirationAlert(this.document.expirationDate);
    if (expirationData && expirationData.alertState) {
      const prefix = expirationData.alertState === 'expired' ? 'Expirado el:' : 'Expira el:';
      const date = new Date(this.document.expirationDate).toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toUpperCase();
      return `${prefix} ${date}`;
    }
    return '';
  }

  // Abrir drawer de documento
  openDocDrawer(event: Event): void {
    const classList = (event.target as HTMLElement).classList
    if (classList.contains('anticon')) {
      this.documentService.openDocumentInNewTab(this.document);
    } else {
      this.docDrawer?.close();
      combineLatest({
        isMobile: this.screenService.isMobile$,
        isMedium: this.screenService.isMedium$,
      }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
        this.docDrawer = this.drawerService.create({
          nzWidth: 635,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMask: false,
          nzContent: DocDrawerComponent,
          nzData: {
            document: this.document,
          }
        });

        // Espera a que el drawer esté completamente abierto
        this.docDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          this.docDrawer.getContentComponent().deleteEvent.pipe(take(1)).subscribe((docs: Document[]) => {
           this.deleteEvent.emit();
          });
        });
      });
    }
  }
}
